'use client';
import React from 'react';
import useImageDisplay from './useImageDisplay';
// ***** 수정: 올바른 경로에서 cn 임포트 *****
import { cn } from '../../utils';
/**
 * 이미지를 안전하게 표시하는 컴포넌트
 * 오류 처리 및 로딩 상태 관리 기능 포함
 */ export default function ImageDisplay(param) {
    var src = param.src, _param_alt = param.alt, alt = _param_alt === void 0 ? '이미지' : _param_alt, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, onClick = param.onClick, onError = param.onError, _param_showErrorUI = param.showErrorUI, showErrorUI = _param_showErrorUI === void 0 ? true : _param_showErrorUI, fallbackSrc = param.fallbackSrc, imageBlob = param.imageBlob, apiUrl = param.apiUrl;
    var _useImageDisplay = useImageDisplay({
        src: src,
        onError: onError,
        fallbackSrc: fallbackSrc,
        imageBlob: imageBlob,
        apiUrl: apiUrl
    }), imgRef = _useImageDisplay.imgRef, currentSrcToLoad = _useImageDisplay.currentSrcToLoad, status = _useImageDisplay.status, fadeIn = _useImageDisplay.fadeIn, handleLoad = _useImageDisplay.handleLoad, handleError = _useImageDisplay.handleError, log = _useImageDisplay.log, currentAttemptIndex = _useImageDisplay.currentAttemptIndex;
    log("[ImageDisplay] Rendering: status=".concat(status, ", fadeIn=").concat(fadeIn, ", srcToLoad=").concat(currentSrcToLoad));
    if (status === 'failed' && showErrorUI) {
        log('모든 이미지 로드 실패, 에러 UI 표시');
        return /*#__PURE__*/ React.createElement("div", {
            className: "w-full h-full flex items-center justify-center bg-gray-200 dark:bg-gray-800 ".concat(className)
        }, /*#__PURE__*/ React.createElement("span", {
            className: "text-sm text-gray-500 dark:text-gray-400 p-2 text-center"
        }, "이미지를 불러올 수 없습니다"));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative w-full h-full ".concat(className),
        onClick: onClick
    }, status === 'loading' && /*#__PURE__*/ React.createElement("div", {
        className: "absolute inset-0 bg-gray-200 dark:bg-gray-800 flex items-center justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-8 h-8 border-2 border-gray-400 border-t-blue-500 rounded-full animate-spin"
    })), /*#__PURE__*/ React.createElement("img", {
        ref: imgRef,
        src: currentSrcToLoad,
        alt: alt,
        className: cn("w-full h-full object-cover transition-opacity duration-300", status === 'loaded' && fadeIn ? "opacity-100" : "opacity-0"),
        onError: handleError,
        onLoad: handleLoad,
        loading: "lazy",
        crossOrigin: "",
        referrerPolicy: "no-referrer",
        key: "".concat(currentSrcToLoad, "-").concat(status, "-").concat(currentAttemptIndex)
    }));
}
